import React, { useEffect, useState } from "react";

const Timer = ({
  lastDate,
  lastTime,
  startMessage,
  endMessage,
  noteMessage,
}) => {
  const cleanDateString = (date, time) => {
    if (!date || !time) return null;
    const cleanedDate = date.replace(/(\d+)(st|nd|rd|th)/, "$1");
    return new Date(`${cleanedDate} ${time}`);
  };

  const [timeLeft, setTimeLeft] = useState(() => calculateTimeLeft());
  const [showdata, setShowdata] = useState(null);

  function calculateTimeLeft() {
    const target = cleanDateString(lastDate, lastTime);
    if (!target) return null;

    const now = new Date();
    const difference = target - now;

    if (difference <= 0) return null;

    return {
      days: String(Math.floor(difference / (1000 * 60 * 60 * 24))).padStart(
        2,
        "0"
      ),
      hours: String(Math.floor((difference / (1000 * 60 * 60)) % 24)).padStart(
        2,
        "0"
      ),
      minutes: String(Math.floor((difference / 1000 / 60) % 60)).padStart(
        2,
        "0"
      ),
      seconds: String(Math.floor((difference / 1000) % 60)).padStart(2, "0"),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const updated = calculateTimeLeft();
      setTimeLeft(updated);
      setShowdata(true);
      if (!updated) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [lastDate, lastTime]);
  if (!showdata) return <></>;

  return (
    <div
      style={{ padding: "10px", fontFamily: "monospace", textAlign: "center" }}
    >
      {timeLeft ? (
        <>
          <h3>
            {startMessage} &nbsp;
            <div className="timer">
              <span className="timer-date">{timeLeft.days}d</span> &nbsp; —
              &nbsp;
              <span>{timeLeft.hours}h</span> : <span>{timeLeft.minutes}m</span>{" "}
              : <span>{timeLeft.seconds}s</span>
            </div>
          </h3>
        </>
      ) : (
        <>
          <div className="times-up-bg">
            <div className="col-md-8 text-centar mx-auto">
              <div>
                <h4>
                  <b>{endMessage}</b>
                </h4>
              </div>
              <div>
                <h6>
                  <b style={{ color: "red" }}>Note:</b>
                  {noteMessage}
                </h6>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Timer;
